import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-100 container-fluid" }

import { onBeforeMount, onMounted, ref } from 'vue';
import BlockvrockHeader from '../../components/header/BlockvrockHeader.vue';
import TabContainer from './TabContainer.vue';
import BlocklySection from './BlocklySection.vue';
import CodeModeSection from './CodeModeSection.vue';
import HtmlSection from './HtmlSection.vue';
import DynamicDomScriptSection from './DynamicDomScriptSection.vue';
import BlocklyXmlSection from './BlocklyXmlSection.vue';
import { useRoute,useRouter } from 'vue-router';
import { DialogHandler } from '../../components/dialog/DialogHandler';
import { SessionMemory } from '../../utils/SessionMemory';
import { MessageDialog } from '../../../framework/frontend/MessageDialog';
import { translation } from '../../lang/Translation';
import { blocklyStore } from '../../blockly/blocklyStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlocklyPage',
  setup(__props) {

const t = translation;
const selectedPage = ref('blockly');
const onChangePage = (page: string) => {
  selectedPage.value = page;
};

const route = useRoute();

onMounted(() => {
  const skechFabToken = route.query.skechfab_token as string;
  if (skechFabToken) {
    SessionMemory.instance.skechFabAuthCode = skechFabToken;
    DialogHandler.showSketchFabListDialog();
  }
});

const router = useRouter();
router.beforeResolve(router.beforeEach(async to => {
  if(to.name === "ListPage"){
    await blocklyStore.save();
    await MessageDialog.info(`${t.to("保存しました","save_success")}`);
    blocklyStore.workspace.clear();
  }
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BlockvrockHeader),
    _createVNode(TabContainer, {
      class: "px-5",
      onOnChangePage: onChangePage
    }),
    _withDirectives(_createVNode(BlocklySection, { class: "mx-5" }, null, 512), [
      [_vShow, selectedPage.value === 'blockly']
    ]),
    (selectedPage.value === 'code')
      ? (_openBlock(), _createBlock(CodeModeSection, {
          key: 0,
          class: "mx-5"
        }))
      : _createCommentVNode("", true),
    (selectedPage.value === 'html')
      ? (_openBlock(), _createBlock(HtmlSection, {
          key: 1,
          class: "mx-5"
        }))
      : _createCommentVNode("", true),
    (selectedPage.value === 'dynamicDomScript')
      ? (_openBlock(), _createBlock(DynamicDomScriptSection, {
          key: 2,
          class: "mx-5"
        }))
      : _createCommentVNode("", true),
    (selectedPage.value === 'blocklyXml')
      ? (_openBlock(), _createBlock(BlocklyXmlSection, {
          key: 3,
          class: "mx-5"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})